<template>
  <div class="homeWrap mainBox wow animate__animated animate__fadeIn">
    <div class="title" style="text-align: center">
      <div class="text1">物联产品</div>
      <div class="text2">让万物互联，让安全数据更聚焦</div>
    </div>
    <div class="productsContainer">
      <div
        class="productCard maria"
        v-for="(item, index) in productList"
        :key="index"
        @click="navTo('/product/hardware')"
      >
        <div class="productImage">
          <template v-if="item.hasImage">
            <img
              class="img"
              :src="item.image"
              fit="contain"
              alt=""
            />
          </template>
          <div v-else class="noImagePlaceholder">
            暂无图片
          </div>
        </div>
        <div class="productText">
          <div class="productTitle">{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { navTo } from "@/utils/util";

//产品数据
const productList = ref([
  {
    title: "智能柜系列",
    description: "融合物联网、AI识别、RFID等技术，实现危化品精准管控和实时监测",
    image: require("@/assets/images/UIV5/moduleCabinet.png"),
    hasImage: true
  },
  {
    title: "智能终端管理",
    description: "高精度传感与智能算法结合，实现物品重量精准测量和使用登记管理",
    image: require("@/assets/images/UIV5/device2.png"),
    hasImage: true
  },
  {
    title: "门禁管理",
    description: "运用无线射频识别技术，实现快速识别和高安全性门禁控制",
    image: require("@/assets/images/UIV5/device3.png"),
    hasImage: true
  },
  {
    title: "智慧班牌",
    description: "融合人脸识别、RFID刷卡等技术，实现快速无感考勤和智能校园管理",
    image: require("@/assets/images/UIV5/device4.png"),
    hasImage: true
  }
]);
</script>

<style lang="scss" scoped>
.productsContainer {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2vw;
  width: 100%;
  padding: 0 1vw;
  box-sizing: border-box;
}

.productCard {
  background: #fff;
  border-radius: 0.5rem;
  box-shadow: 0px 4px 15px 0px rgba(218, 229, 238, 0.5);
  overflow: hidden;
  cursor: pointer;
  padding: 10% 10% 20%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.productImage {
  width: 100%;
  height: clamp(12rem, 15vw, 14.5rem);
  flex: 0 0 clamp(12rem, 15vw, 14.5rem);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  overflow: hidden;

  .img{
    width: 90%;
    height: 90%;
    object-fit: contain;
  }
}

.noImagePlaceholder {
  color: #999;
  font-size: 1.1vw;
  text-align: center;
}

.productText {
  text-align: center;
  margin-top: auto;
  min-height: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.productTitle {
  font-size: 1.1vw;
  font-weight: 400;
  color: #3D3D3D;
}
</style>
